import PropTypes from 'prop-types'
import styled from 'styled-components'
import Image from 'next/image'

import { FadeUp } from '@happymoneyinc/move'

import Container from './Container'
import Display from './Display'
import Headline from './Headline'
import TextPopup from './TextPopup'
import CTA from './CTA'
import { headlineMediumStyles } from './../utils/cmsStyles'

const Process = (props) => {
  const {
    data: {
      primary: {
        button_tip: buttonTip,
        button_href: buttonHref,
        button_text: buttonText,
        headline,
        subtext
      },
      items,
    },
    processHeadline,
    ctaHref,
  } = props

  return (
    <Wrapper center>
      <TextPopup>
        <Title size="small" testID="process-title" element="h2">{processHeadline || headline}</Title>
        <SubText size="small">{subtext}</SubText>
      </TextPopup>

      <List>
        {items.map((item, index) => (
          <ListItem key={item.image.url}>
            <FadeUp>
              <ImageWrapper maxWidth={item.maxwidth}>
                <Image layout="responsive" alt={item.image.alt} src={item.image.url} height={item.image.dimensions.height} width={item.image.dimensions.width} />
              </ImageWrapper>

              <Number>{`((${ index + 1 }))`}</Number>
              <StyledHeadline size="medium" data-testid={`process-item-headline-${ index + 1 }`}>{item.headline}</StyledHeadline>
            </FadeUp>
          </ListItem>
        ))}
      </List>

      <CTA
        align={'center'}
        buttonHref={buttonHref || ctaHref}
        buttonContent={buttonText}
        buttonTip={buttonTip}
        buttonColor="azure"
        buttonMobileWidth={'100%'}
        testID="process"
      />
    </Wrapper>
  )
}

const ImageWrapper = styled.div`
  max-width: ${ ({ maxWidth }) => `${ maxWidth }px` };
  margin: 0 auto;
`

const Title = styled(Display)`
  margin: 0 auto 24px;

  @media screen and (max-width: ${ (props) => props.theme.breakpoints.xs1 }) {
    max-width: 250px;
  }
`

const SubText = styled(Headline)`
  max-width: 470px;
  margin: 0 auto;

  @media screen and (max-width: ${ (props) => props.theme.breakpoints.xs1 }) {
    ${ headlineMediumStyles }

    max-width: 285px;
  }
`

const StyledHeadline = styled(Headline)`
  margin: 0;
  font-family: ${ ({ theme }) => `${ theme.fonts.MabryProBold }` };
`

const Number = styled.p`
  margin: 32px 0 0;
  font-feature-settings: 'ss10' on;
  font-size: 32px;
`

const ListItem = styled.li`
  width: 100%;
`

const List = styled.ul`
  align-items: flex-end;
  flex-direction: column;
  display: flex;
  width: 100%;
  padding: 0;
  margin: 80px 0 50px;
  list-style: none;
  row-gap: 100px;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.sm }) {
    flex-direction: row;
    margin: 120px 0 70px;
  }
`

const Wrapper = styled(Container)`
  text-align: center;
  background-color: ${ ({ theme }) => theme.colors.cream };
`

Process.defaultProps = {
  processHeadline: null,
  ctaHref: null,
}

Process.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  processHeadline: PropTypes.string,
  ctaHref: PropTypes.string,
}

export default Process
